/**
 * @fileOverview The sample company's packets, one of each kind. Part of the sample world
 * (`samples/world.ts`, which re-exports it) and kept in a file of its own for one reason: the shared
 * ways (`services/viewHelp/ways.ts`) read a packet's kind to find the catalogue list it sits in, and the
 * ways are part of every session's bundle. The rest of the world is loaded only inside the Erklärung's
 * frame (`main.js`), and importing it from the ways would ship it to every reader.
 */

/** Pakete: one of each kind, each a bundle of the world's catalogue records. */
export const WORLD_PACKETS = [
  { id: "pkt-fundament", name: "Fundament", type: "MATERIAL", items: ["mat-beton", "mat-stahl", "mat-schalung"] },
  { id: "pkt-erdbau", name: "Erdbau", type: "MACHINE", items: ["mach-bagger", "mach-kipper", "mach-platte"] },
  {
    id: "pkt-baustelle",
    name: "Baustelleneinrichtung",
    type: "ADDITIONAL_EFFORT",
    items: ["eff-anfahrt", "eff-entsorgung"],
  },
] as const
